enum TableViewModeEnum {
  PROSPECTS = 'prospects',
  CAMPAIGNS = 'campaigns',
}

export default TableViewModeEnum
